<div id="custodia-derivativos" *ngIf="rows.length > 0">
    <mat-expansion-panel>
        <mat-expansion-panel-header>                                  
            <mat-panel-title class="titulo-painel-custodia">                
                <div style="float: left;">
                    <span>DIVIDENDOS/JPC</span> <br />
                </div>  
                <div class="cor_estrategia"></div>
            </mat-panel-title>
            <mat-panel-description>
                <span class="texto-estrategia">
                    <span>Valor Total:</span><br />
                    <span><b>R$ {{ total_financeiro_atual | number : '1.2-2'}}</b></span> 
                </span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        
        <ng-template matExpansionPanelContent>
            <ngx-datatable 
                #tableAtivo
                class='material'                             
                [loadingIndicator]="loadingListaAtivo"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50"                                                      
                [rowHeight]="'auto'"
                [rows]='rows'
            >        

                <ngx-datatable-column name="Data" prop="data_compra" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{row.execution_date | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>            
            
                <ngx-datatable-column name="Ativo/Empresa" prop="ativo" [sortable]="true">
                    <ng-template  let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span 
                            style="padding: 5px; border-radius: 10px;"
                            [className]="row.cor_hexadecimal" 
                        >
                            <b>{{ getAtivo(row) }}</b>
                        </span>   
                    </ng-template>
                </ngx-datatable-column>   
                
                <ngx-datatable-column name="Tipo" prop="type" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                        
                        <span >
                            {{ getType(row.type) }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>  
            
                <ngx-datatable-column name="Valor" prop="total_value" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                                                    
                    <span>
                        R$ {{ row.total_value | number : '1.2-2'}}
                    </span>
                    </ng-template>
                </ngx-datatable-column>
            </ngx-datatable>
        </ng-template>
    </mat-expansion-panel>
</div>
